import { Stack, Typography } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import Page from 'src/components/Page'
import PageHeader from 'src/components/page-header'
import FindCompany from 'src/views/company/FindCompany'

const CompanyList = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const field = searchParams.get("field") || "";
    const q = searchParams.get("q") || "";
    const [reload, setReload] = useState(0)
    const [selected, setSelected] = useState({})

    const handleClick = () => {
        window.opener.companyReceiver(selected);
        self.close();
    }

    const showTitle = (field) => {
        switch (field) {
            case 'com_code':
                return '사업자등록번호';
            default:
                return '업체명';
        }
    }

    return (
        <Page title="Comapany">
            <Grid container spacing={6}>
                <PageHeader
                    title={
                        <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center">
                            <Typography variant='h5' color='#666CFF'>
                                회사 검색
                            </Typography>
                            <Grid
                                justifyContent="flex-end"
                                alignItems="center">
                                    <Stack spacing={2} direction="row">
                                        <Button variant='contained' onClick={handleClick}> 적용 </Button>
                                        <Button variant='outlined' color='secondary' onClick={() => {self.close()}}> 취소 </Button>
                                    </Stack>                                
                            </Grid>
                        </Grid>
                    }
                    subtitle={
                        <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'center', width: '100%' }}>
                            <Typography variant='body2'>{`선택된 ${showTitle(field)} 회사 리스트를 보여줍니다.`}</Typography>
                        </Box>
                    }
                />                
                <Grid item xs={12}>                    
                    <FindCompany field={field} q={q} reload={reload} setReload={setReload} selected={selected} setSelected={setSelected} />
                </Grid>
            </Grid>
        </Page>
    )
}

export default CompanyList